import { useState } from 'react'

import clsx from 'clsx'

import QueryLoader from '~/components/QueryLoader'
import { LpiStatCard } from '~/components/stats/LpisStatsCard'
import { useLpiSummary } from '~/components/stats/useLpiSummary'
import SkeletonLoader from '~/components/ui/SkeletonLoader'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import CloseIcon from '~/images/icons/SystemOutlined/Close.svg'
import ThunderIcon from '~/images/stats/Thunder.svg'
import { Button } from '~/ui/Button/Button'
import { ButtonCounter } from '~/ui/Button/ButtonCounter'
import { SliderResponsive } from '~/ui/Drawer/SliderResponsive'

const LpiCounter = () => {
  const ct = useCommonTx('common')
  const [visible, setVisible] = useState(false)

  const { loading, error, overallLpiText } = useLpiSummary()

  const popover = {
    show: () => setVisible(true),
    hide: () => setVisible(false),
  }

  return (
    <QueryLoader
      loading={loading}
      error={error}
      data={!loading}
      LoadingComponent={<SkeletonLoader className='w-[90px] h-[40px]' />}
    >
      {visible && (
        <SliderResponsive onClose={popover.hide}>
          <div className='flex flex-col w-full p-8'>
            <Button kind='icon' size='none' className='absolute top-5 right-5' onClick={popover.hide}>
              <CloseIcon title='x' className='w-8 h-8' />
            </Button>
            <div className='text-heading-2 font-normal mt-6'>{ct('currentLpi')}</div>
            <div className='flex flex-col items-center mt-8 mb-10'>
              <LpiStatCard layoutName='C' />
            </div>
          </div>
        </SliderResponsive>
      )}

      <ButtonCounter onClick={visible ? popover.hide : popover.show}>
        <ThunderIcon title='thunder' className='w-[16px] h-[24px]' />
        <div className='text-subheading-2 text-text-default'>{overallLpiText}</div>
      </ButtonCounter>
    </QueryLoader>
  )
}

export const LpiCounterForPages = ({ className }: { className?: string }) => {
  return (
    <div className={clsx('flex lg:hidden', className)}>
      <LpiCounter />
    </div>
  )
}
